class ImageSlideshow {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.track = wrapper.querySelector('[id^="SlideshowTrack-"]');
    this.slides = Array.from(wrapper.querySelectorAll('.slideshow-slide'));
    this.prevBtn = wrapper.querySelector('[id^="SlidePrev-"]');
    this.nextBtn = wrapper.querySelector('[id^="SlideNext-"]');
    this.counterCurrent = wrapper.querySelector('.slideshow-counter__current');

    this.currentIndex = 0;
    this.autoplay = wrapper.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(wrapper.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }

    this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
    this.wrapper.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    // Basic swipe support
    let touchStartX = 0;
    this.wrapper.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );
    this.wrapper.addEventListener(
      'touchend',
      (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.goTo(this.currentIndex + 1);
          } else {
            this.goTo(this.currentIndex - 1);
          }
          this.restartAutoplay();
        }
      },
      { passive: true }
    );
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = (index + total) % total;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.slides[this.currentIndex].classList.add('is-prev');
    this.slides[newIndex].classList.add('is-active');
    this.slides[newIndex].classList.remove('is-prev');

    if (this.counterCurrent) {
      this.counterCurrent.textContent = newIndex + 1;
    }

    setTimeout(() => {
      this.slides.forEach((slide, i) => {
        if (i !== newIndex) slide.classList.remove('is-prev');
      });
    }, 700);

    this.currentIndex = newIndex;
  }

  startAutoplay() {
    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    if (this.autoplay) this.startAutoplay();
  }
}

function initSlideshows() {
  document.querySelectorAll('.slideshow-wrapper').forEach((wrapper) => {
    if (!wrapper.dataset.initialized) {
      new ImageSlideshow(wrapper);
      wrapper.dataset.initialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initSlideshows);

// Re-init when a section is added/re-rendered in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  const wrapper = event.target.querySelector('.slideshow-wrapper');
  if (wrapper) {
    wrapper.dataset.initialized = '';
    new ImageSlideshow(wrapper);
    wrapper.dataset.initialized = 'true';
  }
});